var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7988 20.3528C27.7988 21.4485 28.1032 21.6109 28.7931 21.8544L29.828 22.2196V18.77H29.2192C28.4482 18.77 27.7988 19.4802 27.7988 20.3528Z",
    fill: "#1EC677",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8711 29.9301H33.4798C34.2712 29.9301 34.9003 29.2198 34.9003 28.3473C34.9003 27.2516 34.5959 27.0892 33.906 26.8457L32.8711 26.4805V29.9301Z",
    fill: "#1EC677",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7313 11.1196L42.5716 15.2794C42.2672 15.5838 41.8816 15.7258 41.4961 15.7258C41.1106 15.7258 40.725 15.5838 40.4206 15.2794C39.8322 14.6909 39.8322 13.7169 40.4206 13.1285L44.5804 8.96869C41.0091 5.92494 36.4029 4.05811 31.3503 4.05811C20.1493 4.05811 11.0586 13.1488 11.0586 24.3498C11.0586 35.5508 20.1493 44.6414 31.3503 44.6414C42.5513 44.6414 51.6419 35.5508 51.6419 24.3498C51.6419 19.2971 49.7751 14.6909 46.7313 11.1196ZM34.9013 23.9845C36.2 24.4512 37.9451 25.3846 37.9451 28.3675C37.9451 30.904 35.9362 32.994 33.4809 32.994H32.8721V33.5013C32.8721 34.3333 32.1822 35.0232 31.3503 35.0232C30.5183 35.0232 29.8284 34.3333 29.8284 33.5013V32.994H29.6661C26.9673 32.994 24.7555 30.7214 24.7555 27.9211C24.7555 27.0689 25.4454 26.3789 26.2773 26.3789C27.1093 26.3789 27.7992 27.0689 27.7992 27.9008C27.7992 29.0169 28.6312 29.93 29.6661 29.93H29.8284V25.4252L27.7992 24.715C26.5006 24.2483 24.7555 23.3149 24.7555 20.332C24.7555 17.7956 26.7643 15.7055 29.2196 15.7055H29.8284V15.2185C29.8284 14.3866 30.5183 13.6966 31.3503 13.6966C32.1822 13.6966 32.8721 14.3866 32.8721 15.2185V15.7258H33.0345C35.7333 15.7258 37.9451 17.9985 37.9451 20.7987C37.9451 21.6307 37.2551 22.3206 36.4232 22.3206C35.5912 22.3206 34.9013 21.6307 34.9013 20.7987C34.9013 19.6827 34.0693 18.7696 33.0345 18.7696H32.8721V23.2743L34.9013 23.9845Z",
    fill: "#1EC677",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0426 3.47004C52.8802 3.10479 52.5962 2.80041 52.2106 2.63808C52.028 2.5772 51.8454 2.53662 51.6425 2.53662H43.5258C42.6938 2.53662 42.0039 3.22654 42.0039 4.0585C42.0039 4.89045 42.6938 5.58037 43.5258 5.58037H47.9697L44.5809 8.96908C45.352 9.63871 46.0622 10.3489 46.7319 11.12L50.1206 7.73129V12.1752C50.1206 13.0071 50.8105 13.697 51.6425 13.697C52.4744 13.697 53.1643 13.0071 53.1643 12.1752V4.0585C53.1643 3.85558 53.1237 3.67295 53.0426 3.47004Z",
    fill: "#1EC677",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2773 34.9009C19.2773 36.8692 20.7992 38.452 22.6661 38.452H26.4809C28.1042 38.452 29.4232 37.0722 29.4232 35.3474C29.4232 33.5008 28.6115 32.8312 27.4143 32.4051L21.3065 30.2744C20.1093 29.8483 19.2977 29.199 19.2977 27.3322C19.2977 25.6277 20.6166 24.2275 22.2399 24.2275H26.0548C27.9216 24.2275 29.4435 25.8103 29.4435 27.7786",
    stroke: "#1EC677",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3496 22.2188V40.4813",
    stroke: "#1EC677",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3503 11.0581C13.1493 11.0581 4.05859 20.1488 4.05859 31.3498C4.05859 39.3447 8.68511 46.2641 15.4219 49.5717",
    stroke: "#1EC677",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6413 31.3501C44.6413 42.5511 35.5506 51.6418 24.3496 51.6418",
    stroke: "#1EC677",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6421 19.1748V11.0581H36.5254",
    stroke: "#1EC677",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4961 21.2039L44.6419 11.0581",
    stroke: "#1EC677",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMoney);
export default __webpack_public_path__ + "static/media/send-money.82d30a51f53ad91faebc6185eaeb8479.svg";
export { ForwardRef as ReactComponent };